import {Directive, HostListener} from '@angular/core';
import {NgModel} from '@angular/forms';

@Directive({
    selector: '[stripHiddenCharacters]',
    standalone: false
})
export class StripHiddenCharacters {
  constructor(private ngModel: NgModel) {}

  @HostListener('ngModelChange', ['$event'])
  onInput(value: unknown) {
    if (typeof value === 'string') {
      const cleaned = value.replace(/\t|\n|\r/g, '');
      if (value !== cleaned) {
        this.ngModel.control?.setValue(cleaned, {emitEvent: false});
      }
    }
  }
}
